import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import React from "react";
import TextTranslationEditor, {TranslationField} from "./TextTranslationEditor";
import {AreaLanguageOption, TextTranslation} from "../types";

type Props = {
    isOpen: boolean
    onClose: () => void
    areaId?: string
    clientId?: string
    defaultLanguage?: string
    availableLanguages?: AreaLanguageOption[]
    publishedAt?: number
    fields: TranslationField[]
    canEdit: boolean
    title?: string
    description?: string
    onTranslationSaved?: (translation: TextTranslation) => void
}

const TextTranslationModal = ({
    isOpen,
    onClose,
    areaId,
    clientId,
    defaultLanguage,
    availableLanguages,
    publishedAt,
    fields,
    canEdit,
    title,
    description,
    onTranslationSaved
}: Props) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size={"4xl"} blockScrollOnMount={false}>
            <ModalOverlay/>
            <ModalContent maxW={"90vw"}>
                <ModalHeader>{title || "Translations"}</ModalHeader>
                <ModalCloseButton/>
                <ModalBody pb={6}>
                    <TextTranslationEditor
                        areaId={areaId}
                        clientId={clientId}
                        defaultLanguage={defaultLanguage}
                        availableLanguages={availableLanguages}
                        publishedAt={publishedAt}
                        fields={fields}
                        canEdit={canEdit}
                        title={title}
                        description={description}
                        onTranslationSaved={onTranslationSaved}
                        showHeader={false}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default TextTranslationModal;
